import PropTypes from 'prop-types'
import { partial } from 'lodash'

import { namespace, schema } from './config'
import { MuraEditor } from './editor'
import { muraSchema } from './schema'
import { getNoTicketDocPath } from '../Common'
import { useFetchDoc } from '../DocHelper'
import { referenceDoc } from '../Reference'
import { EditorLoader } from '../SchemaBaseEditorLoader'
import { _queryMura } from './loader.gql'

const getPath = partial(getNoTicketDocPath, namespace, schema)

export const queryManifest = {
  gql: _queryMura,
  name: 'queryMura',
  getPath,
}

export const generateReferenceDoc = partial(
  referenceDoc,
  'name',
  getPath,
  schema,
  namespace,
)

export function MuraEditorLoader({ docId }) {
  return (
    <EditorLoader
      DialogComp={MuraEditor}
      useFetchDocAndTicket={partial(
        useFetchDoc,
        _queryMura,
        'queryMura',
        docId,
      )}
      currentSchema={muraSchema}
    />
  )
}

MuraEditorLoader.propTypes = {
  docId: PropTypes.string.isRequired,
}

export default MuraEditorLoader
